(function () {
  'use strict';

  // Shows an honest, live-computed note on the sticker-pack upsell card:
  // - if the order already qualifies for free shipping without the add-on
  //   (e.g. quantity 2+), says so plainly — no false "add this" pitch.
  // - if adding the add-on would cross the threshold, pitches it.
  // - once checked and it crosses, confirms it's unlocked.
  // - otherwise (adding it still wouldn't be enough), stays hidden.
  // Recomputes on quantity change and on the upsell toggle.
  document.querySelectorAll('[data-section-type="product"]').forEach(function (root) {
    var note = root.querySelector('[data-free-shipping-note]');
    if (!note) return;

    var threshold = parseFloat(root.dataset.freeShippingThreshold);
    var basePrice = parseFloat(root.dataset.basePrice);
    if (!threshold || !basePrice) return;

    var quantityInput = root.querySelector('[data-quantity-input]');
    var upsell = root.querySelector('[data-upsell]');
    var upsellPrice = upsell ? parseFloat(upsell.dataset.upsellPrice) || 0 : 0;

    function isUpsellChecked() {
      return upsell ? upsell.classList.contains('is-checked') : false;
    }

    function update() {
      var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      var withoutAddon = qty * basePrice;
      var withAddon = qty * (basePrice + upsellPrice);

      if (withoutAddon >= threshold) {
        note.textContent = note.dataset.already;
        note.hidden = false;
        note.classList.remove('is-cta');
      } else if (withAddon >= threshold) {
        if (isUpsellChecked()) {
          note.textContent = note.dataset.active;
          note.classList.remove('is-cta');
        } else {
          note.textContent = note.dataset.cta;
          note.classList.add('is-cta');
        }
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', update);
      quantityInput.addEventListener('input', update);
    }
    if (upsell) {
      // The toggle's class change happens synchronously in the click handler
      // registered by product-add-to-cart-v2.js; read it right after.
      upsell.addEventListener('click', function () { window.setTimeout(update, 0); });
    }

    update();
  });
})();
